import { ability } from "@/plugins/Casl";
import store from "@/store";

export default (permission) => {
  return ({ next }) => {
    if (!ability.can(permission)) {
      store.commit("disableAccessToView");
    }
    return next();
  };
};
